import { BaseRouteReuseStrategy } from '@angular/router';
import type { ActivatedRouteSnapshot, DetachedRouteHandle } from '@angular/router';

export class SummaryMapReuseStrategy extends BaseRouteReuseStrategy {

  private handle: DetachedRouteHandle | null = null;

  private isSummaryMapRoute(route: ActivatedRouteSnapshot): boolean {
    return route.routeConfig?.path === 'map'
      && route.parent?.routeConfig?.path === '';
  }

  override shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return this.isSummaryMapRoute(route);
  }

  override store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void {
    if (this.isSummaryMapRoute(route)) {
      this.handle = handle;
    }
  }

  override shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return this.isSummaryMapRoute(route) && this.handle !== null;
  }

  override retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return this.isSummaryMapRoute(route) ? this.handle : null;
  }
}
